"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convert_nutritionix_food = exports.get_recent_weights = exports.search_upc = exports.get_user_data = exports.get_monthly_weight_change = exports.add_weight_entry = exports.get_weight = exports.get_recent_foods = exports.check_for_token = exports.login = exports.get_weekly_calories = exports.update_log_item_qty = exports.validate_token = exports.register_user = exports.delete_food_from_log = exports.add_food_to_log = exports.get_food_from_date = exports.search_nutritionix_food_nutrients = exports.search_food = void 0;
var axios_1 = __importDefault(require("axios"));
var superagent_1 = __importDefault(require("superagent"));
var store_1 = require("./store");
// import { Weight_Entry } from './Components/Weight'
var stored_token = null;
var host = null;
if (window.location.href.includes("localhost")) {
    host = 'http://localhost:3000';
}
else {
    host = "https://calorieserver.michaeldonlan.com";
}
// const host = "https://calorieserver.michaeldonlan.com";
// const host = 'http://157.230.58.188:3000';
// const host = 'https://192.168.0.224:3000'; // for dev purposes, allows access on different computers on same network
// const host = 'http://localhost:3000';
// search the nutritionix db for foods based on a query
function search_food(query) {
    // console.log('searching food')
    return axios_1.default.post("".concat(host, "/search_foods_nutritionix"), {
        headers: { "Authorization": "Bearer ".concat(stored_token) },
        "query": query
    })
        .then(function (res) { return res.data; })
        .catch(function (e) { console.log(e); });
}
exports.search_food = search_food;
// // get nutrient info for a specific item
// export function get_nutrients_for_food(query) {
//     return axios({
//         method: "POST",
//         url: 'https://trackapi.nutritionix.com/v2/natural/nutrients',
//         headers: {
//             "x-app-id": "19cbe08c",
//             "x-app-key": "8dffdef9be5f87ff5ce316816ca87b0a",
//             "x-remote-user-id": 0,
//         },
//         data: {
//             "query": query,
//         }
//     })
//     .then(res => {
//         console.log("get_nutrients_for_food: ", res);
//         // return res;
//     })
//     .catch(e => {
//         console.log(e);
//     })
// }
function search_nutritionix_food_nutrients(name) {
    return axios_1.default.post("".concat(host, "/search_nutritionix_food_nutrients"), { "food_name": name, "token": stored_token })
        .then(function (res) {
        // console.log(res);
        return res.data.foods[0];
        // store.dispatch(set_food_items_today(res.data.rows));
    })
        .catch(function (e) { return console.log(e); });
}
exports.search_nutritionix_food_nutrients = search_nutritionix_food_nutrients;
// get all user foods from today
// export function get_food_from_today() {
//     return axios.get(`${host}/get_food_from_today`)
//     .then(res => {
//         store.dispatch(set_food_items_today(res.data.rows));
//     })
//     .catch(e => console.log(e))
// }
function get_food_from_date(date) {
    return axios_1.default.post("".concat(host, "/get_food_from_date"), { "token": stored_token, "date": date })
        .then(function (res) {
        console.log(res.data.rows);
        store_1.store.dispatch((0, store_1.set_daily_food_items)(res.data.rows));
    })
        .catch(function (e) { return console.log(e); });
}
exports.get_food_from_date = get_food_from_date;
// add a new food to the users food log
function add_food_to_log(new_food, date) {
    return axios_1.default.post("".concat(host, "/add_food_to_log"), { "food": new_food, "date": date, "token": stored_token })
        .then(function (res) {
        // get_nutrients_for_food(new_food.food_name);
    })
        .catch(function (e) { return console.log(e); });
}
exports.add_food_to_log = add_food_to_log;
// delete a food from the users food log
function delete_food_from_log(food) {
    return axios_1.default.post("".concat(host, "/delete_food_from_log"), { "food": food })
        .then(function (res) { })
        .catch(function (e) { return console.log(e); });
}
exports.delete_food_from_log = delete_food_from_log;
// register a new user
function register_user(data) {
    return axios_1.default.post("".concat(host, "/register_user"), { "data": data })
        .then(function (res) {
        localStorage.setItem("token", res.data.token);
        stored_token = res.data.token;
        return res.data.message;
    })
        .catch(function (e) {
        console.log(e.response);
        return e.response.data;
    });
}
exports.register_user = register_user;
function validate_token(token) {
    var _this = this;
    console.log("validating token: " + token);
    return axios_1.default.post("".concat(host, "/validate_token"), { "token": token })
        .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
        var user_data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log(res.data);
                    if (!res.data.valid_token) return [3 /*break*/, 2];
                    store_1.store.dispatch((0, store_1.set_logged_in)(true));
                    store_1.store.dispatch((0, store_1.set_username)(res.data.username));
                    stored_token = token;
                    return [4 /*yield*/, get_user_data()];
                case 1:
                    user_data = _a.sent();
                    console.log(user_data);
                    store_1.store.dispatch((0, store_1.set_user_data)(user_data));
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); })
        .catch(function (e) {
        // console.log(e);
        stored_token = null;
        localStorage.setItem("token", null);
    });
}
exports.validate_token = validate_token;
// // get food details for an array of foods
// export async function get_food_details(foods) {
//     // const foods = ['pizza', 'pasta', 'tacos'];
//     const results = [];
//     for (let i = 0; i < foods.length; i++) {
//         const details = await get_details(foods[i]);
//         results.push(details.data.foods[0]);
//         // console.log(details.data.foods[0].food_name)
//         // console.log(details.data.foods[0].nf_calories)
//     }
//     return results;
// }
// async function get_details(query) {
//     return axios({
//         method: "POST",
//         url: 'https://trackapi.nutritionix.com/v2/natural/nutrients',
//         headers: {
//             "x-app-id": "19cbe08c",
//             "x-app-key": "8dffdef9be5f87ff5ce316816ca87b0a"
//         },
//         data: { "query": query }
//     })
//     .then(res => {
//         // console.log(res);
//         return res;
//     })
//     .catch(e => {
//         console.log(e);
//     })
// }
// updates an existing food item in the users food log
function update_log_item_qty(item, qty) {
    var data = {
        item: item,
        qty: qty,
        token: stored_token,
    };
    return axios_1.default.post("".concat(host, "/update_log_item"), { "data": data })
        .then(function (res) {
        // after we update an item, get the new data from db to show user
        // get_food_from_today();
        // console.log(res);
        return res;
    })
        .catch(function (e) {
        console.log(e);
    });
}
exports.update_log_item_qty = update_log_item_qty;
function get_weekly_calories() {
    return axios_1.default.post("".concat(host, "/get_weekly_calories"), { "token": stored_token })
        .then(function (res) { return res.data; })
        .catch(function (e) { return console.log(e); });
}
exports.get_weekly_calories = get_weekly_calories;
// // Example POST method implementation:
// async function postData(url = '', data = {}) {
//     // Default options are marked with *
//     const response = await fetch(url, {
//       method: 'POST', // *GET, POST, PUT, DELETE, etc.
//       mode: 'cors', // no-cors, *cors, same-origin
//       cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
//       credentials: 'same-origin', // include, *same-origin, omit
//       headers: {
//         'Content-Type': 'application/json'
//         // 'Content-Type': 'application/x-www-form-urlencoded',
//       },
//       redirect: 'follow', // manual, *follow, error
//       referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
//       body: JSON.stringify(data) // body data type must match "Content-Type" header
//     });
//     return response.json(); // parses JSON response into native JavaScript objects
//   }
function login(data) {
    // postData(`${host}/login`, { username: "test", password: "test" })
    // .then((data) => {
    //   console.log(data); // JSON data parsed by `data.json()` call
    // });
    // return superagent.post(`${host}/login`)
    // .send({ username: data.username, password: data.password })
    // .then(res => {
    //     localStorage.setItem("token", res.body.token);
    //     stored_token = res.body.token;
    //     // store.dispatch(set_token(res.body.token));
    //     store.dispatch(set_logged_in(true));
    //     return res.body.message;
    // })
    // .catch(e => {
    //     console.log(e)
    //     return e.message;
    // })
    console.log("start of login--api");
    return superagent_1.default.post("".concat(host, "/login/"))
        .send({ username: data.username, password: data.password })
        .then(function (res) {
        console.log(res.body);
        localStorage.setItem("token", res.body.token);
        stored_token = res.body.token;
        // store.dispatch(set_token(res.body.token));
        store_1.store.dispatch((0, store_1.set_logged_in)(true));
        return res.body.message;
    })
        .catch(function (e) {
        console.log("LOGIN ERROR");
        console.log(e);
        return e.message;
    });
    // return axios.post(`${host}/login/`, { username: data.username, password: data.password })
    // .then(res => {
    //     console.log(res);
    //     localStorage.setItem("token", res.data.token);
    //     stored_token = res.data.token;
    //     // store.dispatch(set_token(res.body.token));
    //     store.dispatch(set_logged_in(true));
    //     return res.data.message;
    // })
    // .catch(e => {
    //     console.log("LOGIN ERROR");
    //     console.log(e)
    //     return e.message;
    // })
}
exports.login = login;
// export function create_user_food(data) {
//     console.log('create_user_food');
//     console.log(data);
//     return superagent.post(`${host}/create_user_food`)
//     .send({"data": data, "token": stored_token})
//     .then(res => {
//         console.log(res);
//         console.log("successfully created new user food")
//         return res.body.message;
//     })
//     .catch(e => {
//         console.log(e)
//         return e.message;
//     })
// }
function check_for_token() {
    var token = localStorage.getItem("token");
    if (token) {
        stored_token = token;
    }
    return token;
}
exports.check_for_token = check_for_token;
function get_recent_foods() {
    return superagent_1.default.post("".concat(host, "/get_recent_foods"))
        .send({ "token": stored_token })
        .set('accept', 'json')
        .then(function (res) { return res.body; })
        .catch(function (e) { return console.log(e); });
}
exports.get_recent_foods = get_recent_foods;
function get_weight() {
    return superagent_1.default.post("".concat(host, "/get_weight"))
        .send({ "token": stored_token })
        .then(function (res) { return res.body; })
        .catch(function (e) { return console.log(e); });
}
exports.get_weight = get_weight;
function add_weight_entry(weight) {
    return superagent_1.default.post("".concat(host, "/add_weight_entry"))
        .send({ "token": stored_token, "weight": weight })
        .then(function (res) { return res.body; })
        .catch(function (e) { return console.log(e); });
}
exports.add_weight_entry = add_weight_entry;
function get_monthly_weight_change() {
    return superagent_1.default.post("".concat(host, "/get_monthly_weight_change"))
        .send({ "token": stored_token })
        .then(function (res) { return res.body; })
        .catch(function (e) { return console.log(e); });
}
exports.get_monthly_weight_change = get_monthly_weight_change;
function get_user_data() {
    return superagent_1.default.post("".concat(host, "/get_user_data"))
        .send({ "token": stored_token })
        .then(function (res) { return res.body; })
        .catch(function (e) { return console.log(e); });
}
exports.get_user_data = get_user_data;
function search_upc(upc) {
    console.log("upc_code: " + upc);
    return superagent_1.default.post("".concat(host, "/search_upc"))
        .send({ "token": stored_token, "upc": upc })
        .then(function (res) { return res.body; })
        .catch(function (e) { return console.log(e); });
}
exports.search_upc = search_upc;
function get_recent_weights() {
    return superagent_1.default.post("".concat(host, "/get_recent_weights"))
        .send({ "token": stored_token })
        .then(function (res) { return res.body; })
        .catch(function (e) { return console.log(e); });
}
exports.get_recent_weights = get_recent_weights;
function get_nutrient(food, index) {
    var value = food.full_nutrients.find(function (a) { return a.attr_id == index; });
    if (value == undefined)
        return 0;
    return value.value;
}
function convert_nutritionix_food(food, meal) {
    // console.log("nutritionix_food: ", nutritionix_food);
    var new_food = {
        food_name: food.food_name,
        calories_per_serving: get_nutrient(food, 208),
        servings: 1,
        serving_qty: food.serving_qty,
        // serving_size: food.serving_unit,
        carbs: get_nutrient(food, 205),
        protein: get_nutrient(food, 203),
        total_fat: get_nutrient(food, 204),
        trans_fat: get_nutrient(food, 605),
        sat_fat: get_nutrient(food, 606),
        poly_fat: get_nutrient(food, 646),
        mono_fat: get_nutrient(food, 645),
        cholesterol: get_nutrient(food, 601),
        sodium: get_nutrient(food, 307),
        potassium: get_nutrient(food, 306),
        fiber: get_nutrient(food, 291),
        sugar: get_nutrient(food, 269),
        vitamin_a: get_nutrient(food, 318),
        vitamin_c: get_nutrient(food, 401),
        calcium: get_nutrient(food, 301),
        iron: get_nutrient(food, 303),
        meal: meal,
        serving_unit: food.serving_unit,
        alt_measures: [],
        photo: food.photo.thumb
    };
    // console.log(food);
    return new_food;
}
exports.convert_nutritionix_food = convert_nutritionix_food;
//# sourceMappingURL=data:application/json;base64,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